<template>
<div>
        <nav>
            <div class="navregular">
                <span>{{ this.$store.state.currentVersion }}</span>
                <router-link to="/">The Chinese Type Archive</router-link>
                <router-link to="/records">View Records</router-link>
            </div>
            <div class="navmobile">
                <router-link to="/records">View Records</router-link>
                <router-link to="/about">About the Archive</router-link>
            </div>
        </nav>
        <header>
        </header>
        <section class="mainbody">
            <!-- PROMO TEXT -->
            <section class="promo">
                <div class="promotext">
                    <h1>字體資料庫</h1>
                    <h2>An on-going, collaborative, open-access database of Chinese typographic resources.</h2>
                    <p><router-link to="/about">Learn More</router-link></p>
                </div>
            </section>
            <!-- CARDS -->
            <section class="cards">
                <!-- TYPEFACES -->
                <a v-if="!this.$store.state.fetchedTypefaceData" class="card"><div class="loading-box"><div></div></div></a>
                <a v-else @click.prevent="goToRecord('typeface', randomtypeface.recordid)" class="card">
                    <div class="card_count">
                        <div class="card_count_fraction">
                            <div>{{ typefaces.findIndex(x => x.recordid === randomtypeface.recordid)+1 }}</div>
                            <div>{{ this.$store.getters.typefaceDataLength }}</div>
                        </div>
                    </div>
                    <div class="card_title">{{ randomtypeface.namech }}</div>
                    <div class="card_meta">
                        <div class="card_meta_translation"><a @click.prevent="goToRecord('typeface', randomtypeface.recordid)">{{ randomtypeface.nameeng }}</a></div>
                        <div class="card_meta_type">
                            <span class="card_meta_type_ch">字體</span> <span class="card_meta_type_eng">Typeface</span>
                        </div>
                    </div>
                </a>
                <!-- CONCEPTS-->
                <a v-if="!this.$store.state.fetchedConceptData" class="card"><div class="loading-box"><div></div></div></a>
                <a v-else @click.prevent="goToRecord('concept', randomconcept.recordid)" class="card">
                        <div class="card_count">
                            <div class="card_count_fraction">
                                <div>{{ concepts.findIndex(x => x.recordid === randomconcept.recordid)+1 }}</div>
                                <div>{{ this.$store.getters.conceptDataLength }}</div>
                            </div>
                        </div>
                        <div class="card_title">{{ randomconcept.namech }}</div>
                        <div class="card_meta">
                            <div class="card_meta_translation"><a @click.prevent="goToRecord('concept', randomconcept.recordid)">{{ randomconcept.nameeng }}</a></div>
                            <div class="card_meta_type">
                                <span class="card_meta_type_ch">詞匯</span> <span class="card_meta_type_eng">Concept</span>
                            </div>
                        </div>
                    </a>
                    <!-- RESOURCES -->
                    <a v-if="!this.$store.state.fetchedResourceData" class="card"><div class="loading-box"><div></div></div></a>
                    <a v-else @click.prevent="goToRecord('resource', randomresource.recordid)" class="card">
                            <div class="card_count">
                                <div class="card_count_fraction">
                                    <div>{{ resources.findIndex(x => x.recordid === randomresource.recordid)+1 }}</div>
                                    <div>{{ this.$store.getters.resourceDataLength }}</div>
                                </div>
                            </div>
                            <div class="card_title">{{ randomresource.namech }}</div>
                            <div class="card_meta">
                                <div class="card_meta_translation"><a @click.prevent="goToRecord('resource', randomresource.recordid)">{{ randomresource.nameeng }}</a></div>
                                <div class="card_meta_type">
                                    <span class="card_meta_type_ch">書刊</span> <span class="card_meta_type_eng">Resource</span>
                                </div>
                            </div>
                    </a>
            </section>
        </section>
</div>
</template>

<script>
import router from '@/router'

export default {
  name: 'HomeViewMain',
  components: {
  },
  computed: {
      typefaces: function(){
          return this.$store.state.fetchedTypefaces
      },
      concepts: function(){
          return this.$store.state.fetchedConcepts
      },
      resources: function(){
          return this.$store.state.fetchedResources
      },
/*      typefacecount: function(){
          return this.typefaces.length
      },
      conceptcount: function(){
          return this.concepts.length
      },
      resourcecount: function(){
          return this.resources.length
      }, */
      randomtypeface: function(){
          return this.typefaces[Math.floor(Math.random()*this.typefaces.length)]
      },
      randomconcept: function(){
          return this.concepts[Math.floor(Math.random()*this.concepts.length)]
      },
      randomresource: function(){
//          return this.resources[Math.floor(Math.random()*this.resources.length)];
        //Only return a random resource with a chinese name
        var tempresource = this.resources[Math.floor(Math.random()*this.resources.length)]

        while (!tempresource.namech) {
            tempresource = this.resources[Math.floor(Math.random()*this.resources.length)]
        }
        
        return tempresource
      }
  },
  methods: {
    goToRecord(selectedrecordtype, selectedrecordid){
        router.push(`/records/` + selectedrecordtype + `/` + selectedrecordid, () => {}) 
    }

  }
}

</script>

<style>
</style>
